import { Text } from "@clipboard-health/ui-react";
import { Stack } from "@mui/material";
import { ProgressBar } from "@src/appV2/lib";
import { type ReactElement } from "react";

interface RequirementProgressBarProps {
  submittedRequirementCount: number;
  totalRequirementCount: number;
}

export function RequirementProgressBar(props: RequirementProgressBarProps): ReactElement {
  const { submittedRequirementCount, totalRequirementCount } = props;

  const percentOfSubmittedRequirement =
    (Math.min(submittedRequirementCount, totalRequirementCount) / totalRequirementCount) * 100;

  return (
    <Stack spacing={2}>
      <Text variant="h3" sx={{ textAlign: "center" }}>
        <b>{submittedRequirementCount}</b> of <b>{totalRequirementCount}</b> required documents
        submitted
      </Text>
      <ProgressBar value={percentOfSubmittedRequirement} />
    </Stack>
  );
}
